<template>
  <div class="app-breadcrumb">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleClick" @tab-remove="handleRemove">
      <el-tab-pane
        v-for="item in visitedViews"
        :key="item.path"
        :label="item.meta.title"
        :name="item.path"
        :closable="item.path !== '/'">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: '',
      visitedViews: []
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.addView(route)
      },
      immediate: true
    }
  },
  methods: {
    addView(route) {
      const { name, path, meta } = route
      const view = { name, path, meta, fullPath: route.fullPath || path }
      // 先激活当前 tab
      this.activeTab = path
      // One tab per path, retaining the latest query/hash for that page.
      const index = this.visitedViews.findIndex(v => v.path === path)
      if (index >= 0) this.visitedViews.splice(index, 1, view)
      else this.visitedViews.push(view)
    },
    handleClick(tab) {
      const view = this.visitedViews.find(v => v.path === tab.name)
      if (view) this.$router.push(view.fullPath)
    },
    handleRemove(targetPath) {
      const tabs = this.visitedViews
      const index = tabs.findIndex(tab => tab.path === targetPath)
      if (index < 0) return
      this.visitedViews = tabs.filter(tab => tab.path !== targetPath)
      if (this.activeTab !== targetPath) return
      const nextTab = tabs[index + 1] || tabs[index - 1]
      this.activeTab = nextTab ? nextTab.path : ''
      this.$router.push(nextTab ? nextTab.fullPath : '/')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin: 0;
}
::v-deep .el-tabs__item {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  font-size: #666;
}
.app-breadcrumb {
  display: inline-block;
  font-size: 14px;
  width: 100%;
  :deep(.el-tabs__header) {
    margin: 0;
  }

  :deep(.el-tabs__nav) {
    border: none;
  }

  :deep(.el-tabs__item) {
    height: 30px;
    line-height: 30px;
    border: 1px solid #d8dce5;
    color: #495060;
    background: #fff;

    &.is-active {
      color: #409eff;
      border-bottom-color: #fff;
    }
  }
}
::v-deep .el-tabs__nav-next,
::v-deep .el-tabs__nav-prev {
  line-height: 30px;
}
</style>
